import { ApiComm } from '../comm';
import { ResponseDTO } from '../dto/ResponseDTO';
import { ReadingScriptStatisticsDTO } from '../dto/ReadingScriptStatisticsDTOs';
import { genNoobookHeader } from './Common';



/**
 * 독서·필사 통계 데이터 조회
 * @param authToken 인증 토큰
 * @param startDate 시작일 (YYYY-MM-DD)
 * @param endDate 종료일 (YYYY-MM-DD)
 */
export function getReadingScriptStatistics(
  authToken: string,
  startDate?: string,
  endDate?: string
): Promise<ResponseDTO<ReadingScriptStatisticsDTO>> {
  // TODO: 서버 API가 준비되면 아래 주석을 해제하고 mock 함수를 제거
  const params: any = {};
  if (startDate) params.queryFr = startDate;
  if (endDate) params.queryTo = endDate;

  return ApiComm.getData<ResponseDTO<ReadingScriptStatisticsDTO>>(
    '/close/v1/admin/bookcase/popular/books',
    params,
    genNoobookHeader(authToken, null, 'application/json', 'app')
  ).then(resp => resp.data);
  

  // Mock data 반환 (서버 API 준비 전까지 사용)
  /*
  return new Promise((resolve) => {
    setTimeout(() => {
        const mockData: ReadingScriptStatisticsDTO = {
          popularBooks: [
            { rank: 1, bookTitle: '도나는 벽품 파랑이 따띈다', author: '작가1', userCount: 453, avgReadPage: 125, avgScore: 4.5 },
            { rank: 2, bookTitle: '쏜다는 취의 지남', author: '작가2', userCount: 384, avgReadPage: 118, avgScore: 4.3 },
            { rank: 3, bookTitle: '그사의 염의 번었는 것', author: '작가3', userCount: 311, avgReadPage: 112, avgScore: 4.2 },
            { rank: 4, bookTitle: '느약과 조움이뽕탐 수 없', author: '작가4', userCount: 286, avgReadPage: 108, avgScore: 4.1 },
            { rank: 5, bookTitle: '격인이 이런된 사고', author: '작가5', userCount: 276, avgReadPage: 105, avgScore: 4.0 },
            { rank: 6, bookTitle: '책 제목 6', author: '작가6', userCount: 265, avgReadPage: 102, avgScore: 3.9 },
            { rank: 7, bookTitle: '책 제목 7', author: '작가7', userCount: 254, avgReadPage: 99, avgScore: 3.8 },
            { rank: 8, bookTitle: '책 제목 8', author: '작가8', userCount: 243, avgReadPage: 96, avgScore: 3.7 },
            { rank: 9, bookTitle: '책 제목 9', author: '작가9', userCount: 232, avgReadPage: 93, avgScore: 3.6 },
            { rank: 10, bookTitle: '책 제목 10', author: '작가10', userCount: 221, avgReadPage: 90, avgScore: 3.5 },
          ],
          popularScriptBooks: [
            { rank: 1, bookTitle: '도나는 벽품 파랑이 따돋다', author: '안령복', userCount: 359, avgScriptPage: 120, avgScore: 4.4 },
            { rank: 2, bookTitle: '쏜다는 취의 지남', author: '이념라', userCount: 423, avgScriptPage: 128, avgScore: 4.6 },
            { rank: 3, bookTitle: '그사의 염의 번었는 것', author: '고제은', userCount: 399, avgScriptPage: 122, avgScore: 4.5 },
            { rank: 4, bookTitle: '느약과 조움이꽁탐 수 없', author: '안비맥', userCount: 300, avgScriptPage: 115, avgScore: 4.2 },
            { rank: 5, bookTitle: '격인이 이런된 사고', author: '손천영', userCount: 383, avgScriptPage: 121, avgScore: 4.4 },
            { rank: 6, bookTitle: '책 제목 6', author: '작가 6', userCount: 372, avgScriptPage: 119, avgScore: 4.3 },
            { rank: 7, bookTitle: '책 제목 7', author: '작가 7', userCount: 361, avgScriptPage: 117, avgScore: 4.2 },
            { rank: 8, bookTitle: '책 제목 8', author: '작가 8', userCount: 350, avgScriptPage: 115, avgScore: 4.1 },
            { rank: 9, bookTitle: '책 제목 9', author: '작가 9', userCount: 339, avgScriptPage: 113, avgScore: 4.0 },
            { rank: 10, bookTitle: '책 제목 10', author: '작가 10', userCount: 328, avgScriptPage: 111, avgScore: 3.9 },
          ],
        };

      const response: ResponseDTO<ReadingScriptStatisticsDTO> = {
        errorCode: 0,
        response: mockData,
        page: {
          current: 1,
          last: 1,
          total: 1,
        },
      };

      resolve(response);
    }, 300); // API 호출 시뮬레이션을 위한 약간의 지연
  });*/
}
